import { ReportTask } from '@knowledge/common/components/ItemSelectV5/utils/trans';
import { overseaTranslate } from 'services/api/overseaTranslate';
import { LRUMap } from 'lib/lruMap';
import { tolgee } from 'services/i18n/tolgee';

const lruMap = new LRUMap<string, string>(200 * 8);

const task = new ReportTask<string>({
  request: (text) => {
    return overseaTranslate(text, 'en-US', 'beisiTag').catch(() => []);
  },
  delay: 16 * 2, // 16为一帧的时间
});

export const getTranslate = (source: string) => {
  return new Promise<string>((resolve) => {
    if (tolgee.getLanguage() === 'zh-CN') {
      return resolve(source);
    }
    const cache = lruMap.get(`${source}-en-US`);
    if (cache) {
      return resolve(cache);
    }
    const _resolve = (val: string) => {
      if (val) {
        lruMap.set(`${source}-en-US`, val);
        return resolve(val);
      } else {
        return resolve(source);
      }
    };
    task.run({
      body: source,
      resolve: _resolve,
    });
  });
};
